import { render, staticRenderFns } from "./RetailCouponFilter.vue?vue&type=template&id=cd047468&"
import script from "./RetailCouponFilter.vue?vue&type=script&lang=js&"
export * from "./RetailCouponFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports